'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:WorkspacesNewCtrl
 * @description
 * # WorkspacesNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('WorkspacesNewCtrl', [
    '$scope', '$rootScope', 'Workspace', '$stateParams', 'toaster', '$state','Employee','$q',
    function ($scope, $rootScope, Workspace, $stateParams, toaster, $state, Employee, $q) {
      $scope.selectedEmployee = ''
    if($stateParams.workspacesId) {
      Workspace.find($stateParams.workspacesId).then(function(response) {
        const workspace = response.data;
        $scope.selectedEmployee = workspace.boss
        $scope.workspaceHash = { 'workspace': workspace };
        $scope.bossesWorkspacesList = workspace.bosses_workspaces
      }, function(error) {
        Workspace.error(error);
      });
    } else {
      $scope.bossesWorkspacesList = []
      $scope.workspaceHash = {};
    }

    $scope.saveWorkspace = function() {
      const data = {
        'workspace': {
          'id': $scope.workspaceHash.workspace.id,
          'name': $scope.workspaceHash.workspace.name,
          'is_notifiable': $scope.workspaceHash.workspace.is_notifiable,
          'bosses_workspaces_attributes': [
            ...$scope.bossesWorkspacesList
          ]
        }
      }
      Workspace.save(data).then((response) => {
        $scope.workspaceHash = {};
        toaster.pop('success', 'Workspace', 'Se creo o se edito correctamente el workspace');
        $state.go('app.workspaces.show', {workspacesId: response.data.id});
      }).catch((error) => {
        Workspace.error(error);
      });
    };

    $scope.employeeSearch = function(searchQuery) {
      if (!searchQuery) {
        return [];
      }
      var employeeParams = {
        'params': {
          'search': searchQuery
        }
      };
      var deferred = $q.defer();
      Employee.index(employeeParams).then(function(response) {
        let response_data = response.data.employees;
        deferred.resolve(response_data);
      }).catch(function(error) {
        Employee.error(error);
        deferred.reject(error);
      });
      return deferred.promise;
    };

    $scope.selectedEmployeeChange = function(employee) {
      if (employee) {
        $scope.bossesWorkspacesList.unshift({
          "employee_id": employee.id,
          "employee": { 
            "id": employee.id,
            "name": employee.name,
          }
        })
        $scope.searchEmployee = ""
      }
    };

    $scope.removeBossesWorkspace = function(id) {
      const item = $scope.bossesWorkspacesList.find(e => e.id === id)
      item._destroy = true
    };

  }]);
